/**
 * Format `remains_seconds` into a localised "X hours Y minutes" string.
 *
 * Uses vue-i18n `tc` so the host application can plug in its own
 * pluralization rules (see ./pluralization.js for the ru rule that matches
 * the keys defined in the task).
 *
 * Always rounds up to at least 1 minute and floors hours.
 */
export function formatRemains(i18n, seconds) {
  const total = Math.max(60, Number(seconds) || 0);
  const h = Math.floor(total / 3600);
  const m = Math.max(1, Math.ceil((total - h * 3600) / 60));
  const hoursStr = h > 0 ? i18n.tc('dialogMetadata.consent.remains.hours', h, {n: h}) : null;
  const minutesStr = i18n.tc('dialogMetadata.consent.remains.minutes', m, {n: m});
  return hoursStr
    ? i18n.t('dialogMetadata.consent.remains.hours_and_minutes', {
        hours: hoursStr,
        minutes: minutesStr,
      })
    : minutesStr;
}
